<div class="sidebar-header">
    <a class="branding" href="/">
        <img [src]="currentTheme === 'dark' ? './assets/images/logo_dark.png' : './assets/images/logo.png'"
            class="branding-logo-expanded" alt="logo" />
        <span class="branding-name ms-2">Identity Admin</span>
    </a>
</div>
<div class="sidebar-main scrollbar-none pt-2">
    <mat-nav-list class="sidemenu d-block">
        <mat-list-item routerLink="/dashboard" routerLinkActive="list-item-active">
            <div class="d-flex flex-row">
                <mat-icon>dashboard</mat-icon>
                Dashboard
            </div>
        </mat-list-item>
    </mat-nav-list>
    <mat-nav-list class="sidemenu d-block">
        <mat-list-item routerLink="/applications" routerLinkActive="list-item-active">
            <div class="d-flex flex-row">
                <mat-icon>apps</mat-icon>
                Applications
            </div>
        </mat-list-item>
    </mat-nav-list>
    <mat-nav-list class="sidemenu d-block">
        <mat-list-item routerLink="/users" routerLinkActive="list-item-active">
            <div class="d-flex flex-row">
                <mat-icon>people</mat-icon>
                Users
            </div>
        </mat-list-item>
    </mat-nav-list>
    <mat-nav-list class="sidemenu d-block">
        <mat-list-item routerLink="/api-keys" routerLinkActive="list-item-active">
            <div class="d-flex flex-row">
                <mat-icon>vpn_key</mat-icon>
                API Keys
            </div>
        </mat-list-item>
    </mat-nav-list>
    <mat-nav-list class="sidemenu d-block">
        <mat-list-item routerLink="/contact-messages" routerLinkActive="list-item-active">
            <div class="d-flex flex-row">
                <mat-icon>mail</mat-icon>
                Contact Messages
            </div>
        </mat-list-item>
    </mat-nav-list>
    <mat-nav-list class="sidemenu d-block">
        <mat-list-item routerLink="/comments" routerLinkActive="list-item-active">
            <div class="d-flex flex-row">
                <mat-icon>comment</mat-icon>
                Comments
            </div>
        </mat-list-item>
    </mat-nav-list>
</div>
